import { render, staticRenderFns } from "./software-3.vue?vue&type=template&id=59773922&"
import script from "./software-3.vue?vue&type=script&lang=js&"
export * from "./software-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports